(function () {
  var overlay = document.querySelector('[data-cart-overlay]');
  var drawer = document.querySelector('[data-cart-drawer]');
  var body = document.querySelector('[data-cart-body]');
  var subtotalEl = document.querySelector('[data-cart-subtotal]');
  var countEls = document.querySelectorAll('[data-cart-count]');
  var shipBar = document.querySelector('[data-ship-bar]');
  var shipMsg = document.querySelector('[data-ship-msg]');
  var shipFill = document.querySelector('[data-ship-fill]');

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency || 'USD' }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2); }
  }

  function openDrawer() { if (overlay) overlay.classList.add('open'); if (drawer) { drawer.classList.add('open'); drawer.setAttribute('aria-hidden', 'false'); } }
  function closeDrawer() { if (overlay) overlay.classList.remove('open'); if (drawer) { drawer.classList.remove('open'); drawer.setAttribute('aria-hidden', 'true'); } }

  function render(cart) {
    countEls.forEach(function (c) { c.textContent = cart.item_count; if (cart.item_count > 0) c.removeAttribute('hidden'); else c.setAttribute('hidden', ''); });
    if (subtotalEl) subtotalEl.textContent = money(cart.total_price, cart.currency);

    if (shipBar && shipMsg && shipFill) {
      var threshold = parseInt(shipBar.getAttribute('data-threshold'), 10) || 0;
      if (threshold > 0) {
        var pct = Math.min(100, Math.round(cart.total_price / threshold * 100));
        shipFill.style.width = pct + '%';
        if (cart.total_price >= threshold) shipMsg.innerHTML = "🎉 You've unlocked free delivery!";
        else shipMsg.innerHTML = 'Add <strong style="color:#F3EDE1">' + money(threshold - cart.total_price, cart.currency) + '</strong> more for free delivery';
        shipBar.style.display = '';
      } else { shipBar.style.display = 'none'; }
    }

    if (!body) return;
    if (!cart.items || cart.items.length === 0) {
      body.innerHTML = '<div class="cd-empty">Your cart is empty.<br>Time to fix the hairline.</div>';
      return;
    }
    body.innerHTML = cart.items.map(function (it) {
      var img = it.image ? it.image.replace(/(\.[a-zA-Z]+)(\?|$)/, '_120x120$1$2') : '';
      var variant = (it.variant_title && it.variant_title !== 'Default Title') ? '<div class="vr">' + it.variant_title + '</div>' : '';
      return '<div class="cd-line">' +
        (img ? '<img src="' + img + '" alt="' + (it.product_title || '') + '">' : '<div class="cd-line-ph"></div>') +
        '<div class="cinfo"><div class="nm">' + it.product_title + '</div>' + variant +
        '<div class="pr">' + money(it.final_line_price, cart.currency) + '</div>' +
        '<div class="cd-qty"><button data-change data-key="' + it.key + '" data-qty="' + (it.quantity - 1) + '" aria-label="Decrease">−</button>' +
        '<span>' + it.quantity + '</span>' +
        '<button data-change data-key="' + it.key + '" data-qty="' + (it.quantity + 1) + '" aria-label="Increase">+</button></div>' +
        '</div></div>';
    }).join('');
  }

  function refresh() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(render); }

  // Intercept add-to-cart forms
  document.addEventListener('submit', function (e) {
    var form = e.target;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var original = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json(); })
      .then(function () { return refresh(); })
      .then(function () { openDrawer(); })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) { btn.disabled = false; btn.textContent = original; } });
  });

  // Quantity change inside drawer
  if (body) {
    body.addEventListener('click', function (e) {
      var b = e.target.closest('[data-change]'); if (!b) return;
      var key = b.getAttribute('data-key');
      var qty = parseInt(b.getAttribute('data-qty'), 10);
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty < 0 ? 0 : qty }) })
        .then(function (r) { return r.json(); })
        .then(render);
    });
  }

  var openBtns = document.querySelectorAll('[data-cart-open]');
  openBtns.forEach(function (b) { b.addEventListener('click', function () { refresh(); openDrawer(); }); });
  var closeBtn = document.querySelector('[data-cart-close]');
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  // Initial paint of ship bar / count
  refresh();
})();
